import api from "../services";

const dashBoardReviewAPI = api.injectEndpoints({
    endpoints: (builder) =>({
        getDashBoardReviews : builder.query({
            query: () => ({
                url: `/api/dashboard/underreview`,
                method: "GET",
              })
        }),
    })
})

export default dashBoardReviewAPI
export const {useGetDashBoardReviewsQuery , useLazyGetDashBoardReviewsQuery} = dashBoardReviewAPI